"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-card.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-card.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.purchaseDetailsFuelDetailsFuelUnitToJSON = exports.purchaseDetailsFuelDetailsFuelUnitFromJSON = exports.purchaseDetailsFuelDetailsFuelTypeToJSON = exports.purchaseDetailsFuelDetailsFuelTypeFromJSON = exports.verificationDataAuthenticationExemptionAuthenticationExemptionTypeToJSON = exports.verificationDataAuthenticationExemptionAuthenticationExemptionTypeFromJSON = exports.verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByToJSON = exports.verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByFromJSON = exports.verificationDataThreeDSecureThreeDSecureResultToJSON = exports.verificationDataThreeDSecureThreeDSecureResultFromJSON = exports.verificationDataVerificationCheckToJSON = exports.verificationDataVerificationCheckFromJSON = exports.cardEntryTypeToJSON = exports.cardEntryTypeFromJSON = exports.PurchaseDetailsReferenceDetails = exports.PurchaseDetailsReceiptDetailsReceiptLineItem = exports.PurchaseDetailsReceiptDetails = exports.PurchaseDetailsLodgingDetails = exports.PurchaseDetailsFuelDetails = exports.PurchaseDetailsFlightDetailsFlightSegment = exports.PurchaseDetailsFlightDetails = exports.PurchaseDetails = exports.VerificationDataAuthenticationExemption = exports.VerificationDataThreeDSecure = exports.VerificationData = exports.PurchaseTransfer = exports.CardPaymentContext = exports.PurchaseDetailsFuelDetailsFuelUnit = exports.PurchaseDetailsFuelDetailsFuelType = exports.VerificationDataAuthenticationExemptionAuthenticationExemptionType = exports.VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy = exports.VerificationDataThreeDSecureThreeDSecureResult = exports.VerificationDataVerificationCheck = exports.CardEntryType = void 0;
const amount_1 = require("../common/amount");
const card_details_1 = require("../common/card-details");
const merchant_1 = require("../common/merchant");
const wallet_provider_1 = require("../common/wallet-provider");
const dispute_context_1 = require("./dispute-context");
const protobufPackage = 'com.step.common.proto';
var CardEntryType;
(function (CardEntryType) {
    CardEntryType["INVALID_CARD_ENTRY_TYPE"] = "INVALID_CARD_ENTRY_TYPE";
    CardEntryType["SWIPE"] = "SWIPE";
    CardEntryType["CHIP"] = "CHIP";
    CardEntryType["CONTACTLESS"] = "CONTACTLESS";
    CardEntryType["KEYED_IN"] = "KEYED_IN";
    CardEntryType["OTHER"] = "OTHER";
    CardEntryType["ONLINE"] = "ONLINE";
    CardEntryType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardEntryType || (exports.CardEntryType = CardEntryType = {}));
var VerificationDataVerificationCheck;
(function (VerificationDataVerificationCheck) {
    VerificationDataVerificationCheck["INVALID_VERIFICATION_CHECK"] = "INVALID_VERIFICATION_CHECK";
    VerificationDataVerificationCheck["MATCH"] = "MATCH";
    VerificationDataVerificationCheck["MISMATCH"] = "MISMATCH";
    VerificationDataVerificationCheck["NOT_PROVIDED"] = "NOT_PROVIDED";
    VerificationDataVerificationCheck["UNRECOGNIZED"] = "UNRECOGNIZED";
})(VerificationDataVerificationCheck || (exports.VerificationDataVerificationCheck = VerificationDataVerificationCheck = {}));
var VerificationDataThreeDSecureThreeDSecureResult;
(function (VerificationDataThreeDSecureThreeDSecureResult) {
    VerificationDataThreeDSecureThreeDSecureResult["INVALID_THREE_D_SECURE_RESULT"] = "INVALID_THREE_D_SECURE_RESULT";
    /**
     * AUTHENTICATED - Authentication successful.
     */
    VerificationDataThreeDSecureThreeDSecureResult["AUTHENTICATED"] = "AUTHENTICATED";
    /**
     * FAILED - Authentication failed.
     */
    VerificationDataThreeDSecureThreeDSecureResult["FAILED"] = "FAILED";
    /**
     * ATTEMPT_ACKNOWLEDGED - The merchant attempted to authenticate the authorization, but the
     * cardholder is not enrolled or was unable to reach Stripe.
     */
    VerificationDataThreeDSecureThreeDSecureResult["ATTEMPT_ACKNOWLEDGED"] = "ATTEMPT_ACKNOWLEDGED";
    /**
     * REQUIRED - The authorization was declined because regulatory requirements mandated
     * an authentication for this transaction but it wasn’t submitted
     * correctly by the merchant, and they didn’t claim an applicable
     * exemption.
     */
    VerificationDataThreeDSecureThreeDSecureResult["REQUIRED"] = "REQUIRED";
    VerificationDataThreeDSecureThreeDSecureResult["UNRECOGNIZED"] = "UNRECOGNIZED";
})(VerificationDataThreeDSecureThreeDSecureResult || (exports.VerificationDataThreeDSecureThreeDSecureResult = VerificationDataThreeDSecureThreeDSecureResult = {}));
var VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy;
(function (VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy) {
    VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy["INVALID_CLAIMED_BY"] = "INVALID_CLAIMED_BY";
    VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy["CLAIMED_BY_ACQUIRER"] = "CLAIMED_BY_ACQUIRER";
    VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy["CLAIMED_BY_ISSUER"] = "CLAIMED_BY_ISSUER";
    VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy["UNRECOGNIZED"] = "UNRECOGNIZED";
})(VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy || (exports.VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy = VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy = {}));
var VerificationDataAuthenticationExemptionAuthenticationExemptionType;
(function (VerificationDataAuthenticationExemptionAuthenticationExemptionType) {
    VerificationDataAuthenticationExemptionAuthenticationExemptionType["INVALID_AUTHENTICATION_EXEMPTION_TYPE"] = "INVALID_AUTHENTICATION_EXEMPTION_TYPE";
    VerificationDataAuthenticationExemptionAuthenticationExemptionType["UNKNOWN_AUTHENTICATION_EXEMPTION_TYPE"] = "UNKNOWN_AUTHENTICATION_EXEMPTION_TYPE";
    VerificationDataAuthenticationExemptionAuthenticationExemptionType["LOW_VALUE_TRANSACTION"] = "LOW_VALUE_TRANSACTION";
    VerificationDataAuthenticationExemptionAuthenticationExemptionType["TRANSACTION_RISK_ANALYSIS"] = "TRANSACTION_RISK_ANALYSIS";
    VerificationDataAuthenticationExemptionAuthenticationExemptionType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(VerificationDataAuthenticationExemptionAuthenticationExemptionType || (exports.VerificationDataAuthenticationExemptionAuthenticationExemptionType = VerificationDataAuthenticationExemptionAuthenticationExemptionType = {}));
var PurchaseDetailsFuelDetailsFuelType;
(function (PurchaseDetailsFuelDetailsFuelType) {
    PurchaseDetailsFuelDetailsFuelType["INVALID_FUEL_TYPE"] = "INVALID_FUEL_TYPE";
    PurchaseDetailsFuelDetailsFuelType["DIESEL"] = "DIESEL";
    PurchaseDetailsFuelDetailsFuelType["UNLEADED_PLUS"] = "UNLEADED_PLUS";
    PurchaseDetailsFuelDetailsFuelType["UNLEADED_REGULAR"] = "UNLEADED_REGULAR";
    PurchaseDetailsFuelDetailsFuelType["UNLEADED_SUPER"] = "UNLEADED_SUPER";
    PurchaseDetailsFuelDetailsFuelType["OTHER"] = "OTHER";
    PurchaseDetailsFuelDetailsFuelType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PurchaseDetailsFuelDetailsFuelType || (exports.PurchaseDetailsFuelDetailsFuelType = PurchaseDetailsFuelDetailsFuelType = {}));
var PurchaseDetailsFuelDetailsFuelUnit;
(function (PurchaseDetailsFuelDetailsFuelUnit) {
    PurchaseDetailsFuelDetailsFuelUnit["INVALID_FUEL_UNIT"] = "INVALID_FUEL_UNIT";
    PurchaseDetailsFuelDetailsFuelUnit["US_GALLON"] = "US_GALLON";
    PurchaseDetailsFuelDetailsFuelUnit["LITER"] = "LITER";
    PurchaseDetailsFuelDetailsFuelUnit["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PurchaseDetailsFuelDetailsFuelUnit || (exports.PurchaseDetailsFuelDetailsFuelUnit = PurchaseDetailsFuelDetailsFuelUnit = {}));
function createBaseCardPaymentContext() {
    return {
        mcc: '',
        terminalId: '',
        entryType: CardEntryType.INVALID_CARD_ENTRY_TYPE,
        processorTxId: '',
        walletProvider: wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER,
        foreignAmount: undefined,
        cardId: '',
        cardUserId: '',
        cardType: card_details_1.CardType.INVALID_CARD_TYPE,
        cardPanSuffix: '',
        accountOwnerUserId: '',
        merchantDescriptor: undefined,
        merchantPreview: undefined,
        dispute: undefined,
        verificationData: undefined,
        issuerDeclined: false,
        purchaseDetails: undefined,
        purchaseTransfer: undefined,
        redeemedByPaymentId: '',
        alternateAccountId: '',
        tokenId: '',
        verifiedByFraudChallenge: false,
    };
}
exports.CardPaymentContext = {
    fromJSON(object) {
        const message = {
            mcc: isSet(object.mcc) ? globalThis.String(object.mcc) : '',
            verifiedByFraudChallenge: isSet(object.verifiedByFraudChallenge)
                ? globalThis.Boolean(object.verifiedByFraudChallenge)
                : false,
        };
        if (isSet(object.terminalId)) {
            message.terminalId = globalThis.String(object.terminalId);
        }
        if (isSet(object.entryType)) {
            message.entryType = cardEntryTypeFromJSON(object.entryType);
        }
        if (isSet(object.processorTxId)) {
            message.processorTxId = globalThis.String(object.processorTxId);
        }
        if (isSet(object.walletProvider)) {
            message.walletProvider = (0, wallet_provider_1.walletProviderFromJSON)(object.walletProvider);
        }
        if (isSet(object.foreignAmount)) {
            message.foreignAmount = amount_1.Amount.fromJSON(object.foreignAmount);
        }
        if (isSet(object.cardId)) {
            message.cardId = globalThis.String(object.cardId);
        }
        if (isSet(object.cardUserId)) {
            message.cardUserId = globalThis.String(object.cardUserId);
        }
        if (isSet(object.cardType)) {
            message.cardType = (0, card_details_1.cardTypeFromJSON)(object.cardType);
        }
        if (isSet(object.cardPanSuffix)) {
            message.cardPanSuffix = globalThis.String(object.cardPanSuffix);
        }
        if (isSet(object.accountOwnerUserId)) {
            message.accountOwnerUserId = globalThis.String(object.accountOwnerUserId);
        }
        if (isSet(object.merchantDescriptor)) {
            message.merchantDescriptor = merchant_1.MerchantDescriptor.fromJSON(object.merchantDescriptor);
        }
        if (isSet(object.merchantPreview)) {
            message.merchantPreview = merchant_1.MerchantPreview.fromJSON(object.merchantPreview);
        }
        if (isSet(object.dispute)) {
            message.dispute = dispute_context_1.DisputeContext.fromJSON(object.dispute);
        }
        if (isSet(object.verificationData)) {
            message.verificationData = exports.VerificationData.fromJSON(object.verificationData);
        }
        if (isSet(object.issuerDeclined)) {
            message.issuerDeclined = globalThis.Boolean(object.issuerDeclined);
        }
        if (isSet(object.purchaseDetails)) {
            message.purchaseDetails = exports.PurchaseDetails.fromJSON(object.purchaseDetails);
        }
        if (isSet(object.purchaseTransfer)) {
            message.purchaseTransfer = exports.PurchaseTransfer.fromJSON(object.purchaseTransfer);
        }
        if (isSet(object.redeemedByPaymentId)) {
            message.redeemedByPaymentId = globalThis.String(object.redeemedByPaymentId);
        }
        if (isSet(object.alternateAccountId)) {
            message.alternateAccountId = globalThis.String(object.alternateAccountId);
        }
        if (isSet(object.tokenId)) {
            message.tokenId = globalThis.String(object.tokenId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.mcc !== '') {
            obj.mcc = message.mcc;
        }
        if (message.terminalId !== undefined && message.terminalId !== '') {
            obj.terminalId = message.terminalId;
        }
        if (message.entryType !== undefined && message.entryType !== CardEntryType.INVALID_CARD_ENTRY_TYPE) {
            obj.entryType = cardEntryTypeToJSON(message.entryType);
        }
        if (message.processorTxId !== undefined && message.processorTxId !== '') {
            obj.processorTxId = message.processorTxId;
        }
        if (message.walletProvider !== undefined &&
            message.walletProvider !== wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER) {
            obj.walletProvider = (0, wallet_provider_1.walletProviderToJSON)(message.walletProvider);
        }
        if (message.foreignAmount !== undefined) {
            obj.foreignAmount = amount_1.Amount.toJSON(message.foreignAmount);
        }
        if (message.cardId !== undefined && message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.cardUserId !== undefined && message.cardUserId !== '') {
            obj.cardUserId = message.cardUserId;
        }
        if (message.cardType !== undefined && message.cardType !== card_details_1.CardType.INVALID_CARD_TYPE) {
            obj.cardType = (0, card_details_1.cardTypeToJSON)(message.cardType);
        }
        if (message.cardPanSuffix !== undefined && message.cardPanSuffix !== '') {
            obj.cardPanSuffix = message.cardPanSuffix;
        }
        if (message.accountOwnerUserId !== undefined && message.accountOwnerUserId !== '') {
            obj.accountOwnerUserId = message.accountOwnerUserId;
        }
        if (message.merchantDescriptor !== undefined) {
            obj.merchantDescriptor = merchant_1.MerchantDescriptor.toJSON(message.merchantDescriptor);
        }
        if (message.merchantPreview !== undefined) {
            obj.merchantPreview = merchant_1.MerchantPreview.toJSON(message.merchantPreview);
        }
        if (message.dispute !== undefined) {
            obj.dispute = dispute_context_1.DisputeContext.toJSON(message.dispute);
        }
        if (message.verificationData !== undefined) {
            obj.verificationData = exports.VerificationData.toJSON(message.verificationData);
        }
        if (message.issuerDeclined !== undefined && message.issuerDeclined !== false) {
            obj.issuerDeclined = message.issuerDeclined;
        }
        if (message.purchaseDetails !== undefined) {
            obj.purchaseDetails = exports.PurchaseDetails.toJSON(message.purchaseDetails);
        }
        if (message.purchaseTransfer !== undefined) {
            obj.purchaseTransfer = exports.PurchaseTransfer.toJSON(message.purchaseTransfer);
        }
        if (message.redeemedByPaymentId !== undefined && message.redeemedByPaymentId !== '') {
            obj.redeemedByPaymentId = message.redeemedByPaymentId;
        }
        if (message.alternateAccountId !== undefined && message.alternateAccountId !== '') {
            obj.alternateAccountId = message.alternateAccountId;
        }
        if (message.tokenId !== undefined && message.tokenId !== '') {
            obj.tokenId = message.tokenId;
        }
        if (message.verifiedByFraudChallenge !== false) {
            obj.verifiedByFraudChallenge = message.verifiedByFraudChallenge;
        }
        return obj;
    },
    create(base) {
        return exports.CardPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPaymentContext();
        message.mcc = object.mcc ?? '';
        message.terminalId = object.terminalId ?? '';
        message.entryType = object.entryType ?? CardEntryType.INVALID_CARD_ENTRY_TYPE;
        message.processorTxId = object.processorTxId ?? '';
        message.walletProvider = object.walletProvider ?? wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER;
        message.foreignAmount = (object.foreignAmount !== undefined && object.foreignAmount !== null)
            ? amount_1.Amount.fromPartial(object.foreignAmount)
            : undefined;
        message.cardId = object.cardId ?? '';
        message.cardUserId = object.cardUserId ?? '';
        message.cardType = object.cardType ?? card_details_1.CardType.INVALID_CARD_TYPE;
        message.cardPanSuffix = object.cardPanSuffix ?? '';
        message.accountOwnerUserId = object.accountOwnerUserId ?? '';
        message.merchantDescriptor =
            (object.merchantDescriptor !== undefined && object.merchantDescriptor !== null)
                ? merchant_1.MerchantDescriptor.fromPartial(object.merchantDescriptor)
                : undefined;
        message.merchantPreview =
            (object.merchantPreview !== undefined && object.merchantPreview !== null)
                ? merchant_1.MerchantPreview.fromPartial(object.merchantPreview)
                : undefined;
        message.dispute = (object.dispute !== undefined && object.dispute !== null)
            ? dispute_context_1.DisputeContext.fromPartial(object.dispute)
            : undefined;
        message.verificationData =
            (object.verificationData !== undefined && object.verificationData !== null)
                ? exports.VerificationData.fromPartial(object.verificationData)
                : undefined;
        message.issuerDeclined = object.issuerDeclined ?? false;
        message.purchaseDetails =
            (object.purchaseDetails !== undefined && object.purchaseDetails !== null)
                ? exports.PurchaseDetails.fromPartial(object.purchaseDetails)
                : undefined;
        message.purchaseTransfer =
            (object.purchaseTransfer !== undefined && object.purchaseTransfer !== null)
                ? exports.PurchaseTransfer.fromPartial(object.purchaseTransfer)
                : undefined;
        message.redeemedByPaymentId = object.redeemedByPaymentId ?? '';
        message.alternateAccountId = object.alternateAccountId ?? '';
        message.tokenId = object.tokenId ?? '';
        message.verifiedByFraudChallenge = object.verifiedByFraudChallenge ?? false;
        return message;
    },
};
function createBasePurchaseTransfer() {
    return { accountId: '', movedAtMs: '0' };
}
exports.PurchaseTransfer = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            movedAtMs: isSet(object.movedAtMs) ? globalThis.String(object.movedAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.movedAtMs !== '0') {
            obj.movedAtMs = message.movedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseTransfer();
        message.accountId = object.accountId ?? '';
        message.movedAtMs = object.movedAtMs ?? '0';
        return message;
    },
};
function createBaseVerificationData() {
    return {
        addressLine1: VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK,
        addressPostalCode: VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK,
        cvc: VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK,
        expiry: VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK,
        threeDSecure: undefined,
        authenticationExemption: undefined,
    };
}
exports.VerificationData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.addressLine1)) {
            message.addressLine1 = verificationDataVerificationCheckFromJSON(object.addressLine1);
        }
        if (isSet(object.addressPostalCode)) {
            message.addressPostalCode = verificationDataVerificationCheckFromJSON(object.addressPostalCode);
        }
        if (isSet(object.cvc)) {
            message.cvc = verificationDataVerificationCheckFromJSON(object.cvc);
        }
        if (isSet(object.expiry)) {
            message.expiry = verificationDataVerificationCheckFromJSON(object.expiry);
        }
        if (isSet(object.threeDSecure)) {
            message.threeDSecure = exports.VerificationDataThreeDSecure.fromJSON(object.threeDSecure);
        }
        if (isSet(object.authenticationExemption)) {
            message.authenticationExemption = exports.VerificationDataAuthenticationExemption.fromJSON(object.authenticationExemption);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressLine1 !== undefined &&
            message.addressLine1 !== VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK) {
            obj.addressLine1 = verificationDataVerificationCheckToJSON(message.addressLine1);
        }
        if (message.addressPostalCode !== undefined &&
            message.addressPostalCode !== VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK) {
            obj.addressPostalCode = verificationDataVerificationCheckToJSON(message.addressPostalCode);
        }
        if (message.cvc !== undefined &&
            message.cvc !== VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK) {
            obj.cvc = verificationDataVerificationCheckToJSON(message.cvc);
        }
        if (message.expiry !== undefined &&
            message.expiry !== VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK) {
            obj.expiry = verificationDataVerificationCheckToJSON(message.expiry);
        }
        if (message.threeDSecure !== undefined) {
            obj.threeDSecure = exports.VerificationDataThreeDSecure.toJSON(message.threeDSecure);
        }
        if (message.authenticationExemption !== undefined) {
            obj.authenticationExemption = exports.VerificationDataAuthenticationExemption.toJSON(message.authenticationExemption);
        }
        return obj;
    },
    create(base) {
        return exports.VerificationData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerificationData();
        message.addressLine1 = object.addressLine1 ??
            VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK;
        message.addressPostalCode = object.addressPostalCode ??
            VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK;
        message.cvc = object.cvc ?? VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK;
        message.expiry = object.expiry ?? VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK;
        message.threeDSecure = (object.threeDSecure !== undefined && object.threeDSecure !== null)
            ? exports.VerificationDataThreeDSecure.fromPartial(object.threeDSecure)
            : undefined;
        message.authenticationExemption =
            (object.authenticationExemption !== undefined && object.authenticationExemption !== null)
                ? exports.VerificationDataAuthenticationExemption.fromPartial(object.authenticationExemption)
                : undefined;
        return message;
    },
};
function createBaseVerificationDataThreeDSecure() {
    return { result: VerificationDataThreeDSecureThreeDSecureResult.INVALID_THREE_D_SECURE_RESULT };
}
exports.VerificationDataThreeDSecure = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.result)) {
            message.result = verificationDataThreeDSecureThreeDSecureResultFromJSON(object.result);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.result !== undefined &&
            message.result !==
                VerificationDataThreeDSecureThreeDSecureResult.INVALID_THREE_D_SECURE_RESULT) {
            obj.result = verificationDataThreeDSecureThreeDSecureResultToJSON(message.result);
        }
        return obj;
    },
    create(base) {
        return exports.VerificationDataThreeDSecure.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerificationDataThreeDSecure();
        message.result = object.result ??
            VerificationDataThreeDSecureThreeDSecureResult.INVALID_THREE_D_SECURE_RESULT;
        return message;
    },
};
function createBaseVerificationDataAuthenticationExemption() {
    return {
        claimedBy: VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy.INVALID_CLAIMED_BY,
        type: VerificationDataAuthenticationExemptionAuthenticationExemptionType
            .INVALID_AUTHENTICATION_EXEMPTION_TYPE,
    };
}
exports.VerificationDataAuthenticationExemption = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.claimedBy)) {
            message.claimedBy =
                verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByFromJSON(object.claimedBy);
        }
        if (isSet(object.type)) {
            message.type = verificationDataAuthenticationExemptionAuthenticationExemptionTypeFromJSON(object.type);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.claimedBy !== undefined &&
            message.claimedBy !==
                VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy.INVALID_CLAIMED_BY) {
            obj.claimedBy = verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByToJSON(message.claimedBy);
        }
        if (message.type !== undefined &&
            message.type !==
                VerificationDataAuthenticationExemptionAuthenticationExemptionType
                    .INVALID_AUTHENTICATION_EXEMPTION_TYPE) {
            obj.type = verificationDataAuthenticationExemptionAuthenticationExemptionTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.VerificationDataAuthenticationExemption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerificationDataAuthenticationExemption();
        message.claimedBy = object.claimedBy ??
            VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy.INVALID_CLAIMED_BY;
        message.type = object.type ??
            VerificationDataAuthenticationExemptionAuthenticationExemptionType
                .INVALID_AUTHENTICATION_EXEMPTION_TYPE;
        return message;
    },
};
function createBasePurchaseDetails() {
    return {
        flight: undefined,
        fuel: undefined,
        lodging: undefined,
        receipt: undefined,
        reference: undefined,
    };
}
exports.PurchaseDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.flight)) {
            message.flight = exports.PurchaseDetailsFlightDetails.fromJSON(object.flight);
        }
        if (isSet(object.fuel)) {
            message.fuel = exports.PurchaseDetailsFuelDetails.fromJSON(object.fuel);
        }
        if (isSet(object.lodging)) {
            message.lodging = exports.PurchaseDetailsLodgingDetails.fromJSON(object.lodging);
        }
        if (isSet(object.receipt)) {
            message.receipt = exports.PurchaseDetailsReceiptDetails.fromJSON(object.receipt);
        }
        if (isSet(object.reference)) {
            message.reference = exports.PurchaseDetailsReferenceDetails.fromJSON(object.reference);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.flight !== undefined) {
            obj.flight = exports.PurchaseDetailsFlightDetails.toJSON(message.flight);
        }
        if (message.fuel !== undefined) {
            obj.fuel = exports.PurchaseDetailsFuelDetails.toJSON(message.fuel);
        }
        if (message.lodging !== undefined) {
            obj.lodging = exports.PurchaseDetailsLodgingDetails.toJSON(message.lodging);
        }
        if (message.receipt !== undefined) {
            obj.receipt = exports.PurchaseDetailsReceiptDetails.toJSON(message.receipt);
        }
        if (message.reference !== undefined) {
            obj.reference = exports.PurchaseDetailsReferenceDetails.toJSON(message.reference);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseDetails();
        message.flight = (object.flight !== undefined && object.flight !== null)
            ? exports.PurchaseDetailsFlightDetails.fromPartial(object.flight)
            : undefined;
        message.fuel = (object.fuel !== undefined && object.fuel !== null)
            ? exports.PurchaseDetailsFuelDetails.fromPartial(object.fuel)
            : undefined;
        message.lodging = (object.lodging !== undefined && object.lodging !== null)
            ? exports.PurchaseDetailsLodgingDetails.fromPartial(object.lodging)
            : undefined;
        message.receipt = (object.receipt !== undefined && object.receipt !== null)
            ? exports.PurchaseDetailsReceiptDetails.fromPartial(object.receipt)
            : undefined;
        message.reference = (object.reference !== undefined && object.reference !== null)
            ? exports.PurchaseDetailsReferenceDetails.fromPartial(object.reference)
            : undefined;
        return message;
    },
};
function createBasePurchaseDetailsFlightDetails() {
    return {
        departureAtMs: '0',
        passengerName: '',
        refundable: undefined,
        travelAgency: '',
        segments: [],
    };
}
exports.PurchaseDetailsFlightDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.departureAtMs)) {
            message.departureAtMs = globalThis.String(object.departureAtMs);
        }
        if (isSet(object.passengerName)) {
            message.passengerName = globalThis.String(object.passengerName);
        }
        if (isSet(object.refundable)) {
            message.refundable = globalThis.Boolean(object.refundable);
        }
        if (isSet(object.travelAgency)) {
            message.travelAgency = globalThis.String(object.travelAgency);
        }
        if (globalThis.Array.isArray(object?.segments)) {
            message.segments = object.segments.map((e) => exports.PurchaseDetailsFlightDetailsFlightSegment.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.departureAtMs !== undefined && message.departureAtMs !== '0') {
            obj.departureAtMs = message.departureAtMs;
        }
        if (message.passengerName !== undefined && message.passengerName !== '') {
            obj.passengerName = message.passengerName;
        }
        if (message.refundable !== undefined) {
            obj.refundable = message.refundable;
        }
        if (message.travelAgency !== undefined && message.travelAgency !== '') {
            obj.travelAgency = message.travelAgency;
        }
        if (message.segments?.length) {
            obj.segments = message.segments.map((e) => exports.PurchaseDetailsFlightDetailsFlightSegment.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseDetailsFlightDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseDetailsFlightDetails();
        message.departureAtMs = object.departureAtMs ?? '0';
        message.passengerName = object.passengerName ?? '';
        message.refundable = object.refundable ?? undefined;
        message.travelAgency = object.travelAgency ?? '';
        message.segments =
            object.segments?.map((e) => exports.PurchaseDetailsFlightDetailsFlightSegment.fromPartial(e)) || [];
        return message;
    },
};
function createBasePurchaseDetailsFlightDetailsFlightSegment() {
    return {
        arrivalAirportCode: '',
        carrier: '',
        departureAirportCode: '',
        flightNumber: '',
        serviceClass: '',
        stopoverAllowed: undefined,
    };
}
exports.PurchaseDetailsFlightDetailsFlightSegment = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.arrivalAirportCode)) {
            message.arrivalAirportCode = globalThis.String(object.arrivalAirportCode);
        }
        if (isSet(object.carrier)) {
            message.carrier = globalThis.String(object.carrier);
        }
        if (isSet(object.departureAirportCode)) {
            message.departureAirportCode = globalThis.String(object.departureAirportCode);
        }
        if (isSet(object.flightNumber)) {
            message.flightNumber = globalThis.String(object.flightNumber);
        }
        if (isSet(object.serviceClass)) {
            message.serviceClass = globalThis.String(object.serviceClass);
        }
        if (isSet(object.stopoverAllowed)) {
            message.stopoverAllowed = globalThis.Boolean(object.stopoverAllowed);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.arrivalAirportCode !== undefined && message.arrivalAirportCode !== '') {
            obj.arrivalAirportCode = message.arrivalAirportCode;
        }
        if (message.carrier !== undefined && message.carrier !== '') {
            obj.carrier = message.carrier;
        }
        if (message.departureAirportCode !== undefined && message.departureAirportCode !== '') {
            obj.departureAirportCode = message.departureAirportCode;
        }
        if (message.flightNumber !== undefined && message.flightNumber !== '') {
            obj.flightNumber = message.flightNumber;
        }
        if (message.serviceClass !== undefined && message.serviceClass !== '') {
            obj.serviceClass = message.serviceClass;
        }
        if (message.stopoverAllowed !== undefined) {
            obj.stopoverAllowed = message.stopoverAllowed;
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseDetailsFlightDetailsFlightSegment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseDetailsFlightDetailsFlightSegment();
        message.arrivalAirportCode = object.arrivalAirportCode ?? '';
        message.carrier = object.carrier ?? '';
        message.departureAirportCode = object.departureAirportCode ?? '';
        message.flightNumber = object.flightNumber ?? '';
        message.serviceClass = object.serviceClass ?? '';
        message.stopoverAllowed = object.stopoverAllowed ?? undefined;
        return message;
    },
};
function createBasePurchaseDetailsFuelDetails() {
    return {
        type: PurchaseDetailsFuelDetailsFuelType.INVALID_FUEL_TYPE,
        unit: PurchaseDetailsFuelDetailsFuelUnit.INVALID_FUEL_UNIT,
        unitCost: '',
        volume: '',
    };
}
exports.PurchaseDetailsFuelDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.type)) {
            message.type = purchaseDetailsFuelDetailsFuelTypeFromJSON(object.type);
        }
        if (isSet(object.unit)) {
            message.unit = purchaseDetailsFuelDetailsFuelUnitFromJSON(object.unit);
        }
        if (isSet(object.unitCost)) {
            message.unitCost = globalThis.String(object.unitCost);
        }
        if (isSet(object.volume)) {
            message.volume = globalThis.String(object.volume);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== undefined &&
            message.type !== PurchaseDetailsFuelDetailsFuelType.INVALID_FUEL_TYPE) {
            obj.type = purchaseDetailsFuelDetailsFuelTypeToJSON(message.type);
        }
        if (message.unit !== undefined &&
            message.unit !== PurchaseDetailsFuelDetailsFuelUnit.INVALID_FUEL_UNIT) {
            obj.unit = purchaseDetailsFuelDetailsFuelUnitToJSON(message.unit);
        }
        if (message.unitCost !== undefined && message.unitCost !== '') {
            obj.unitCost = message.unitCost;
        }
        if (message.volume !== undefined && message.volume !== '') {
            obj.volume = message.volume;
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseDetailsFuelDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseDetailsFuelDetails();
        message.type = object.type ?? PurchaseDetailsFuelDetailsFuelType.INVALID_FUEL_TYPE;
        message.unit = object.unit ?? PurchaseDetailsFuelDetailsFuelUnit.INVALID_FUEL_UNIT;
        message.unitCost = object.unitCost ?? '';
        message.volume = object.volume ?? '';
        return message;
    },
};
function createBasePurchaseDetailsLodgingDetails() {
    return { checkInAtMs: '0', nightsCount: 0 };
}
exports.PurchaseDetailsLodgingDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.checkInAtMs)) {
            message.checkInAtMs = globalThis.String(object.checkInAtMs);
        }
        if (isSet(object.nightsCount)) {
            message.nightsCount = globalThis.Number(object.nightsCount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.checkInAtMs !== undefined && message.checkInAtMs !== '0') {
            obj.checkInAtMs = message.checkInAtMs;
        }
        if (message.nightsCount !== undefined && message.nightsCount !== 0) {
            obj.nightsCount = Math.round(message.nightsCount);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseDetailsLodgingDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseDetailsLodgingDetails();
        message.checkInAtMs = object.checkInAtMs ?? '0';
        message.nightsCount = object.nightsCount ?? 0;
        return message;
    },
};
function createBasePurchaseDetailsReceiptDetails() {
    return { items: [] };
}
exports.PurchaseDetailsReceiptDetails = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.items)) {
            message.items = object.items.map((e) => exports.PurchaseDetailsReceiptDetailsReceiptLineItem.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.items?.length) {
            obj.items = message.items.map((e) => exports.PurchaseDetailsReceiptDetailsReceiptLineItem.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseDetailsReceiptDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseDetailsReceiptDetails();
        message.items =
            object.items?.map((e) => exports.PurchaseDetailsReceiptDetailsReceiptLineItem.fromPartial(e)) || [];
        return message;
    },
};
function createBasePurchaseDetailsReceiptDetailsReceiptLineItem() {
    return { description: '', quantity: '', total: '0', unitCost: '0' };
}
exports.PurchaseDetailsReceiptDetailsReceiptLineItem = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.quantity)) {
            message.quantity = globalThis.String(object.quantity);
        }
        if (isSet(object.total)) {
            message.total = globalThis.String(object.total);
        }
        if (isSet(object.unitCost)) {
            message.unitCost = globalThis.String(object.unitCost);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.quantity !== undefined && message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        if (message.total !== undefined && message.total !== '0') {
            obj.total = message.total;
        }
        if (message.unitCost !== undefined && message.unitCost !== '0') {
            obj.unitCost = message.unitCost;
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseDetailsReceiptDetailsReceiptLineItem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseDetailsReceiptDetailsReceiptLineItem();
        message.description = object.description ?? '';
        message.quantity = object.quantity ?? '';
        message.total = object.total ?? '0';
        message.unitCost = object.unitCost ?? '0';
        return message;
    },
};
function createBasePurchaseDetailsReferenceDetails() {
    return { merchantReference: '' };
}
exports.PurchaseDetailsReferenceDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchantReference)) {
            message.merchantReference = globalThis.String(object.merchantReference);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantReference !== undefined && message.merchantReference !== '') {
            obj.merchantReference = message.merchantReference;
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseDetailsReferenceDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseDetailsReferenceDetails();
        message.merchantReference = object.merchantReference ?? '';
        return message;
    },
};
function cardEntryTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CARD_ENTRY_TYPE':
            return CardEntryType.INVALID_CARD_ENTRY_TYPE;
        case 1:
        case 'SWIPE':
            return CardEntryType.SWIPE;
        case 2:
        case 'CHIP':
            return CardEntryType.CHIP;
        case 3:
        case 'CONTACTLESS':
            return CardEntryType.CONTACTLESS;
        case 4:
        case 'KEYED_IN':
            return CardEntryType.KEYED_IN;
        case 5:
        case 'OTHER':
            return CardEntryType.OTHER;
        case 6:
        case 'ONLINE':
            return CardEntryType.ONLINE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardEntryType.UNRECOGNIZED;
    }
}
exports.cardEntryTypeFromJSON = cardEntryTypeFromJSON;
function cardEntryTypeToJSON(object) {
    switch (object) {
        case CardEntryType.INVALID_CARD_ENTRY_TYPE:
            return 'INVALID_CARD_ENTRY_TYPE';
        case CardEntryType.SWIPE:
            return 'SWIPE';
        case CardEntryType.CHIP:
            return 'CHIP';
        case CardEntryType.CONTACTLESS:
            return 'CONTACTLESS';
        case CardEntryType.KEYED_IN:
            return 'KEYED_IN';
        case CardEntryType.OTHER:
            return 'OTHER';
        case CardEntryType.ONLINE:
            return 'ONLINE';
        case CardEntryType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardEntryTypeToJSON = cardEntryTypeToJSON;
function verificationDataVerificationCheckFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_VERIFICATION_CHECK':
            return VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK;
        case 1:
        case 'MATCH':
            return VerificationDataVerificationCheck.MATCH;
        case 2:
        case 'MISMATCH':
            return VerificationDataVerificationCheck.MISMATCH;
        case 3:
        case 'NOT_PROVIDED':
            return VerificationDataVerificationCheck.NOT_PROVIDED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VerificationDataVerificationCheck.UNRECOGNIZED;
    }
}
exports.verificationDataVerificationCheckFromJSON = verificationDataVerificationCheckFromJSON;
function verificationDataVerificationCheckToJSON(object) {
    switch (object) {
        case VerificationDataVerificationCheck.INVALID_VERIFICATION_CHECK:
            return 'INVALID_VERIFICATION_CHECK';
        case VerificationDataVerificationCheck.MATCH:
            return 'MATCH';
        case VerificationDataVerificationCheck.MISMATCH:
            return 'MISMATCH';
        case VerificationDataVerificationCheck.NOT_PROVIDED:
            return 'NOT_PROVIDED';
        case VerificationDataVerificationCheck.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.verificationDataVerificationCheckToJSON = verificationDataVerificationCheckToJSON;
function verificationDataThreeDSecureThreeDSecureResultFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_THREE_D_SECURE_RESULT':
            return VerificationDataThreeDSecureThreeDSecureResult.INVALID_THREE_D_SECURE_RESULT;
        case 1:
        case 'AUTHENTICATED':
            return VerificationDataThreeDSecureThreeDSecureResult.AUTHENTICATED;
        case 2:
        case 'FAILED':
            return VerificationDataThreeDSecureThreeDSecureResult.FAILED;
        case 3:
        case 'ATTEMPT_ACKNOWLEDGED':
            return VerificationDataThreeDSecureThreeDSecureResult.ATTEMPT_ACKNOWLEDGED;
        case 4:
        case 'REQUIRED':
            return VerificationDataThreeDSecureThreeDSecureResult.REQUIRED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VerificationDataThreeDSecureThreeDSecureResult.UNRECOGNIZED;
    }
}
exports.verificationDataThreeDSecureThreeDSecureResultFromJSON = verificationDataThreeDSecureThreeDSecureResultFromJSON;
function verificationDataThreeDSecureThreeDSecureResultToJSON(object) {
    switch (object) {
        case VerificationDataThreeDSecureThreeDSecureResult.INVALID_THREE_D_SECURE_RESULT:
            return 'INVALID_THREE_D_SECURE_RESULT';
        case VerificationDataThreeDSecureThreeDSecureResult.AUTHENTICATED:
            return 'AUTHENTICATED';
        case VerificationDataThreeDSecureThreeDSecureResult.FAILED:
            return 'FAILED';
        case VerificationDataThreeDSecureThreeDSecureResult.ATTEMPT_ACKNOWLEDGED:
            return 'ATTEMPT_ACKNOWLEDGED';
        case VerificationDataThreeDSecureThreeDSecureResult.REQUIRED:
            return 'REQUIRED';
        case VerificationDataThreeDSecureThreeDSecureResult.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.verificationDataThreeDSecureThreeDSecureResultToJSON = verificationDataThreeDSecureThreeDSecureResultToJSON;
function verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CLAIMED_BY':
            return VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy
                .INVALID_CLAIMED_BY;
        case 1:
        case 'CLAIMED_BY_ACQUIRER':
            return VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy
                .CLAIMED_BY_ACQUIRER;
        case 2:
        case 'CLAIMED_BY_ISSUER':
            return VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy
                .CLAIMED_BY_ISSUER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy.UNRECOGNIZED;
    }
}
exports.verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByFromJSON = verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByFromJSON;
function verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByToJSON(object) {
    switch (object) {
        case VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy.INVALID_CLAIMED_BY:
            return 'INVALID_CLAIMED_BY';
        case VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy
            .CLAIMED_BY_ACQUIRER:
            return 'CLAIMED_BY_ACQUIRER';
        case VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy.CLAIMED_BY_ISSUER:
            return 'CLAIMED_BY_ISSUER';
        case VerificationDataAuthenticationExemptionAuthenticationExemptionClaimedBy.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByToJSON = verificationDataAuthenticationExemptionAuthenticationExemptionClaimedByToJSON;
function verificationDataAuthenticationExemptionAuthenticationExemptionTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_AUTHENTICATION_EXEMPTION_TYPE':
            return VerificationDataAuthenticationExemptionAuthenticationExemptionType
                .INVALID_AUTHENTICATION_EXEMPTION_TYPE;
        case 1:
        case 'UNKNOWN_AUTHENTICATION_EXEMPTION_TYPE':
            return VerificationDataAuthenticationExemptionAuthenticationExemptionType
                .UNKNOWN_AUTHENTICATION_EXEMPTION_TYPE;
        case 2:
        case 'LOW_VALUE_TRANSACTION':
            return VerificationDataAuthenticationExemptionAuthenticationExemptionType
                .LOW_VALUE_TRANSACTION;
        case 3:
        case 'TRANSACTION_RISK_ANALYSIS':
            return VerificationDataAuthenticationExemptionAuthenticationExemptionType
                .TRANSACTION_RISK_ANALYSIS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VerificationDataAuthenticationExemptionAuthenticationExemptionType.UNRECOGNIZED;
    }
}
exports.verificationDataAuthenticationExemptionAuthenticationExemptionTypeFromJSON = verificationDataAuthenticationExemptionAuthenticationExemptionTypeFromJSON;
function verificationDataAuthenticationExemptionAuthenticationExemptionTypeToJSON(object) {
    switch (object) {
        case VerificationDataAuthenticationExemptionAuthenticationExemptionType
            .INVALID_AUTHENTICATION_EXEMPTION_TYPE:
            return 'INVALID_AUTHENTICATION_EXEMPTION_TYPE';
        case VerificationDataAuthenticationExemptionAuthenticationExemptionType
            .UNKNOWN_AUTHENTICATION_EXEMPTION_TYPE:
            return 'UNKNOWN_AUTHENTICATION_EXEMPTION_TYPE';
        case VerificationDataAuthenticationExemptionAuthenticationExemptionType.LOW_VALUE_TRANSACTION:
            return 'LOW_VALUE_TRANSACTION';
        case VerificationDataAuthenticationExemptionAuthenticationExemptionType
            .TRANSACTION_RISK_ANALYSIS:
            return 'TRANSACTION_RISK_ANALYSIS';
        case VerificationDataAuthenticationExemptionAuthenticationExemptionType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.verificationDataAuthenticationExemptionAuthenticationExemptionTypeToJSON = verificationDataAuthenticationExemptionAuthenticationExemptionTypeToJSON;
function purchaseDetailsFuelDetailsFuelTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_FUEL_TYPE':
            return PurchaseDetailsFuelDetailsFuelType.INVALID_FUEL_TYPE;
        case 1:
        case 'DIESEL':
            return PurchaseDetailsFuelDetailsFuelType.DIESEL;
        case 2:
        case 'UNLEADED_PLUS':
            return PurchaseDetailsFuelDetailsFuelType.UNLEADED_PLUS;
        case 3:
        case 'UNLEADED_REGULAR':
            return PurchaseDetailsFuelDetailsFuelType.UNLEADED_REGULAR;
        case 4:
        case 'UNLEADED_SUPER':
            return PurchaseDetailsFuelDetailsFuelType.UNLEADED_SUPER;
        case 5:
        case 'OTHER':
            return PurchaseDetailsFuelDetailsFuelType.OTHER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PurchaseDetailsFuelDetailsFuelType.UNRECOGNIZED;
    }
}
exports.purchaseDetailsFuelDetailsFuelTypeFromJSON = purchaseDetailsFuelDetailsFuelTypeFromJSON;
function purchaseDetailsFuelDetailsFuelTypeToJSON(object) {
    switch (object) {
        case PurchaseDetailsFuelDetailsFuelType.INVALID_FUEL_TYPE:
            return 'INVALID_FUEL_TYPE';
        case PurchaseDetailsFuelDetailsFuelType.DIESEL:
            return 'DIESEL';
        case PurchaseDetailsFuelDetailsFuelType.UNLEADED_PLUS:
            return 'UNLEADED_PLUS';
        case PurchaseDetailsFuelDetailsFuelType.UNLEADED_REGULAR:
            return 'UNLEADED_REGULAR';
        case PurchaseDetailsFuelDetailsFuelType.UNLEADED_SUPER:
            return 'UNLEADED_SUPER';
        case PurchaseDetailsFuelDetailsFuelType.OTHER:
            return 'OTHER';
        case PurchaseDetailsFuelDetailsFuelType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.purchaseDetailsFuelDetailsFuelTypeToJSON = purchaseDetailsFuelDetailsFuelTypeToJSON;
function purchaseDetailsFuelDetailsFuelUnitFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_FUEL_UNIT':
            return PurchaseDetailsFuelDetailsFuelUnit.INVALID_FUEL_UNIT;
        case 1:
        case 'US_GALLON':
            return PurchaseDetailsFuelDetailsFuelUnit.US_GALLON;
        case 2:
        case 'LITER':
            return PurchaseDetailsFuelDetailsFuelUnit.LITER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PurchaseDetailsFuelDetailsFuelUnit.UNRECOGNIZED;
    }
}
exports.purchaseDetailsFuelDetailsFuelUnitFromJSON = purchaseDetailsFuelDetailsFuelUnitFromJSON;
function purchaseDetailsFuelDetailsFuelUnitToJSON(object) {
    switch (object) {
        case PurchaseDetailsFuelDetailsFuelUnit.INVALID_FUEL_UNIT:
            return 'INVALID_FUEL_UNIT';
        case PurchaseDetailsFuelDetailsFuelUnit.US_GALLON:
            return 'US_GALLON';
        case PurchaseDetailsFuelDetailsFuelUnit.LITER:
            return 'LITER';
        case PurchaseDetailsFuelDetailsFuelUnit.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.purchaseDetailsFuelDetailsFuelUnitToJSON = purchaseDetailsFuelDetailsFuelUnitToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-card.js.map